import { mapGetters, mapState } from "vuex"

export default {
  computed: {
    ...mapState({
      isMidPageTransition: (state) =>
        state.misc.band.signup.isTransitioningToSignup,
    }),
    ...mapGetters({
      IS_UNVALID_BAND: "user/IS_UNVALID_BAND",
    }),
    display: function () {
      if (!this.$route.path.includes("/band/signup/"))
        return this.IS_UNVALID_BAND && !this.isMidPageTransition
      return false
    },
  },
}
